export const NEW_ACTIVE_CLIENT = "NEW_ACTIVE_CLIENT";
export const RESET_ACTIVE_CLIENT = "RESET_ACTIVE_CLIENT";
